<template lang="pug">
app-page(:fabItems="fabItems" title="Управление судьей")
  app-toolbar(:title="'Судья'" back)

  v-layout(align-start v-if="currentJudge")
    v-flex(xs7)
      app-sublayer
        app-sublayer-header Управление судьей
        v-layout
          v-flex(xs6)
            app-card(@click.native="showJudge()")
              app-card-header
                 app-card-title {{ judgeFullName }}
                  span.red--text(v-if="currentJudge.archive") (архив)
              app-card-body
                app-card-caption 
                  card-row-label-value(label="Телефон"   :value="currentJudge.phone")
                  card-row-label-value(label="E-mail"    :value="currentJudge.email")
                  card-row-label-value(label="Факс"      :value="currentJudge.fax")
                  card-row-label-value(label="Кабинет"   :value="currentJudge.hall")
                  card-row-label-value(label="Секретарь" :value="currentJudge.secretary")
                  
          v-flex.ml-3
            app-card
              app-card-header(style="background:white;")
                app-card-title Количество дел
              app-card-body.sud-body-hover
                app-card-caption до начала периода
                app-card-caption 
                  b {{ currentJudge.fullcount }}
                app-card-caption с учетом распределения за период
                app-card-caption 
                  b {{ currentJudge.count }}
                app-card-caption Нагрузка дел:
                  b  {{ currentJudge.lazySlave + '%' }}
                  //- card-row-label-value(label="Нагрузка дел" :value="currentJudge.lazySlave + '%'")

        app-sublayer-header.mt-5(@click.native="showBlock.group = !showBlock.group" style="cursor:pointer") 
          v-icon {{ showBlock.group ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          | Рассматриваемые группы категорий ({{ currentJudge.caseCategoryGroup.length }})
        app-empty-list(v-if="currentJudge.caseCategoryGroup.length == 0") Список пуст
        app-group-animation(v-if="showBlock.group")
          app-group-item(v-for="group in currentJudge.caseCategoryGroup" :key="group.id" cols="12")
            app-card
              app-card-body.sud-body-hover
                app-card-title(v-if="group.caseCategory.length > 0") Состав - {{ group.name }}, cодержит категорий - {{ group.caseCategory.length }} шт.
                app-card-title(v-if="group.uCaseCategory && group.uCaseCategory.length > 0") Состав - {{ group.name }}, cодержит статей - {{ group.uCaseCategory.length }} шт.

        app-sublayer-header.mt-5(@click.native="showBlock.category = !showBlock.category" style="cursor:pointer")
         v-icon {{ showBlock.category ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
         | Рассматриваемые категории ({{ currentJudge.caseCategories.length }})
        app-empty-list(v-if="currentJudge.caseCategories.length == 0") Список пуст
        app-group-animation(v-if="showBlock.category")
          app-group-item(v-for="c in currentJudge.caseCategories" :key="c.id" cols="12")
            app-card
              app-card-body.sud-body-hover
                app-card-title {{ c.title }}

        div(v-if="currentJudge.uCaseCategories != null")
          app-sublayer-header.mt-5(@click.native="showBlock.uCategory = !showBlock.uCategory")
          v-icon {{ showBlock.uCategory ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          | Рассматриваемые статьи ({{ currentJudge.uCaseCategories.length }})
          app-empty-list(v-if="currentJudge.uCaseCategories.length == 0") Список пуст
          app-group-animation(v-if="showBlock.uCategory")
            app-group-item(v-for="c in currentJudge.uCaseCategories" :key="c.id" cols="12")
              app-card
                app-card-body.sud-body-hover
                  app-card-title {{ c.title }}

    v-flex.ml-5(xs5)
      app-sublayer
        //- Control Specialization
        specialisationList
        specialisationAdd(v-model="dialog.addSpecialisation" ref="addSpecialisation")
        //- Control Holiday
        holidayList
        holidayAdd(v-model="dialog.holidayAdd" ref="holidayAdd")



  //- Control Judge
  app-dialog(v-model="dialog.judge" header="Профиль судьи" :items="judgeItems")
  judgeEdit(v-model="dialog.judgeEdit" ref="judgeEdit" :signBase64="sign")
  judgeDel(v-model="dialog.judgeDel" ref="judgeDel")
</template>

<script>
import { judgeService } from "@/_services";
import { mapState, mapGetters, mapMutations } from 'vuex'
import { AppDialogConfirm, AppToolbarItemDivider } from '@/components'
import ButtonBackPage from '../components/ButtonBackPage'
import CardRowLabelValue from '../components/CardRowLabelValue'
import JudgeEdit from './components/JudgeEdit'
import JudgeDel from './components/JudgeDel'
import HolidayList from './components/HolidayList'
import HolidayAdd from './components/HolidayAdd'
import SpecialisationList from './components/SpecialisationList' 
import SpecialisationAdd from './components/SpecialisationAdd' 

import moment from 'moment'
moment.locale('ru')

export default {
  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    ButtonBackPage, CardRowLabelValue, 
    JudgeEdit, JudgeDel,
    HolidayList, HolidayAdd,
    SpecialisationList, SpecialisationAdd
  },
  props: {
    judgeId: null
  },
  data () {
    return {
      dialog: {
        holidayAdd: false,
        judge: false,
        judgeEdit: false,
        judgeDel: false,
        addSpecialisation: false,
      },
      showBlock: {
        category: false,
        group: false,
        uCategory: false
      },
      sign: ''
    }
  },
  computed: {
    ...mapState('judgeReestr', ['currentJudge']),
    ...mapGetters('judgeReestr', ['judgeFullName']),

    fabItems () {
      if (this.currentJudge.archive) return null
      return [
        // AppToolbarItemDivider,
        { icon:'event', title:'Добавить отпуск/больничный', action: () => this.$refs.holidayAdd.show() },
        { icon:'gavel', title:'Добавить специализацию', action: () => this.$refs.addSpecialisation.show() },
        AppToolbarItemDivider,
        { icon:'storage', title:'Управление категориями', action: () =>  this.addCategoryOrGroup('')},
        { icon:'line_style', title:'Управление составами', action: () =>  this.addCategoryOrGroup('/group')},
      ]
    },
    judgeItems () {
      return [
        { title: 'Редактировать', icon: 'edit', action: () => this.$refs.judgeEdit.show() }, 
        { title: 'Удалить', icon: 'delete', action: () => this.$refs.judgeDel.show() }
      ]
    },
  },

  methods: {
    ...mapMutations('judgeReestr', ['setJudgeInJudges']),

    getSign () {
      judgeService.getSign(this.currentJudge).then(data => this.sign = data )
    },

    showJudge () {
      if (this.currentJudge.archive) return null
      if (!this.sign) this.getSign()
      this.dialog.judge = true
    },

// Category
    addCategoryOrGroup (group) {
      this.$router.push({ path: `/admin/judges/${this.currentJudge.id}/categories` + group })
    }
  },

  mounted () {
    this.$store.commit('setInJudgeReestr', true)
    this.$store.dispatch('judgeReestr/INIT', { judgeId: this.judgeId })
  },

  beforeDestroy() {
    this.$store.commit('setInJudgeReestr', false)
  }
}
</script>

<style scoped>
.sud-body-hover:hover {
  background: #FFFFFF;
  cursor: auto;
}
</style>